<template>
  <el-popconfirm
    v-model:visible="popoverVisible"
    width="230"
    hide-icon
    @confirm="selectRating(comment)"
    @cancel="selectRating()"
  >
    <template #reference>
      <button
        type="button"
        class="toolbar-button toolbar-button--bad"
        :class="{ 'toolbar-button--active': active }"
        title="Bad response"
        aria-label="Bad response"
        aria-haspopup="dialog"
        :aria-expanded="popoverVisible"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span class="toolbar-icon" v-html="faThumbsDownIcon" />
      </button>
    </template>
    <template #actions="{ confirm, cancel }">
      <el-input v-model="comment" placeholder="Leave a comment" @blur="comment = comment.trim()" />
      <div style="margin-top: 12px">
        <el-button size="small" @click="cancel">Decline</el-button>
        <el-button type="primary" size="small" :disabled="!comment" @click="confirm">
          Submit
        </el-button>
      </div>
    </template>
  </el-popconfirm>
</template>

<script setup>
// Rendered inside the ChatbotResponseToolbar custom element, which is where the shared
// .toolbar-button and .toolbar-icon styles come from.
import { ref, watch } from 'vue';
import { ElPopconfirm, ElInput, ElButton } from 'element-plus';
import faThumbsDownIcon from '@fortawesome/fontawesome-pro/svgs/light/thumbs-down.svg?raw';

defineProps({
  // Whether this is the rating the user last gave. The toolbar owns that, since rating a
  // response one way clears the other rating.
  active: Boolean,
});

// The toolbar owns the comment so it can clear it once the rating has been sent.
const comment = defineModel('comment', { type: String, default: '' });

const emit = defineEmits(['select']);

const popoverVisible = ref(false);
let feedbackHandled = false;

function selectRating(feedbackComment) {
  feedbackHandled = true;
  emit('select', feedbackComment);
}

watch(popoverVisible, visible => {
  if (visible) {
    feedbackHandled = false;
    return;
  }

  if (!feedbackHandled) {
    emit('select', comment.value);
  }
});
</script>
